<template>
  <v-row no-gutters align="center" class="h-screen">
    <!-- Imagen de autenticación -->
    <v-col
      sm="12"
      md="6"
      lg="6"
      class="d-none d-md-flex h-screen bg-primary md:flex-column align-center justify-center"
    >
      <div class="text-center pa-6">
        <h1 class="font-weight-bold alex-brush-regular">
          Recupera tu contraseña
        </h1>
        <v-row align="center" justify="center" class="mt-4">
          <v-col cols="auto">
            <v-tooltip text="Nuestra Web" location="bottom">
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon="mdi-web"
                  @click.prevent="viewModel.goToWeb()"
                ></v-btn>
              </template>
            </v-tooltip>
          </v-col>
          <v-col cols="auto">
            <v-tooltip text="WhatsApp" location="bottom">
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon="mdi-whatsapp"
                  @click.prevent="viewModel.goToWhatsApp()"
                ></v-btn>
              </template>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
    </v-col>

    <!-- Formulario de Recuperación -->
    <v-col
      sm="12"
      md="6"
      lg="6"
      class="flex justify-center align-items-center h-full pa-6"
    >
      <v-card
        class="mx-auto pa-6 pa-md-12 flex justify-center"
        max-width="700"
        border
        flat
      >
        <v-img
          :src="viewModel.logoImage"
          :height="50"
          :width="350"
          cover
          class="h-full w-full mx-auto"
          alt="Logo"
        ></v-img>
        <h4 class="text-h5 font-weight-bold text-center mt-4 mb-8">
          Recupera tu Contraseña
        </h4>

        <v-stepper
          v-model="viewModel.step.value"
          :items="viewModel.stepLabels.value"
          flat
          alt-labels
          color="primary"
          mobile
          class="text-caption"
        >
          <!-- Paso 1: Verificar Documento -->
          <!-- eslint-disable-next-line-->
          <template v-slot:item.1>
            <v-card flat>
              <v-card-text class="px-0 text-subtitle-1">
                <span>
                  Proporciona tu número de documento de identidad y el ID de
                  socio para verificar tu cuenta.
                </span>
              </v-card-text>
              <v-form ref="formStep1" @submit.prevent="viewModel.confirmId">
                <v-text-field
                  v-model="viewModel.dni.value"
                  :rules="viewModel.dniRules"
                  label="Documento de Identidad"
                  required
                  variant="outlined"
                  color="primary"
                  prepend-inner-icon="mdi-card-account-details"
                  hide-details
                ></v-text-field>
                <v-text-field
                  v-model="viewModel.idsocio.value"
                  :rules="viewModel.idSocioRules"
                  label="ID de Socio"
                  required
                  variant="outlined"
                  color="primary"
                  prepend-inner-icon="mdi-account"
                  hide-details
                  class="mt-4"
                ></v-text-field>
              </v-form>
            </v-card>
          </template>

          <!-- Paso 2: Validar Pregunta Secreta -->
          <!-- eslint-disable-next-line-->
          <template v-slot:item.2>
            <v-card flat>
              <v-card-text class="text-subtitle-1">
                <span>Responde a tu pregunta secreta para continuar.</span>
                <p class="font-weight-bold">
                  {{ viewModel.secretQuestion.value }}
                </p>
              </v-card-text>
              <v-form ref="formStep2" @submit.prevent="viewModel.confirmData">
                <v-text-field
                  v-model="viewModel.answer.value"
                  :type="
                    viewModel.isSecretAnswerVisible.value ? 'text' : 'password'
                  "
                  label="Respuesta Secreta"
                  :rules="viewModel.answerRules"
                  variant="outlined"
                  color="primary"
                  hide-details
                >
                  <template v-slot:append-inner>
                    <v-btn
                      variant="plain"
                      @click="viewModel.toggleSecretAnswerVisibility"
                    >
                      <v-icon>{{
                        viewModel.isSecretAnswerVisible.value
                          ? "mdi-eye-off"
                          : "mdi-eye"
                      }}</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-form>
            </v-card>
          </template>

          <!-- Paso 3: Configurar Nueva Contraseña -->
          <!-- eslint-disable-next-line-->
          <template v-slot:item.3>
            <v-card flat>
              <v-card-text class="text-subtitle-1">
                <span> Configura una nueva contraseña para tu cuenta. </span>
              </v-card-text>
              <v-form
                ref="formStep3"
                @submit.prevent="viewModel.changePassword"
              >
                <v-text-field
                  v-model="viewModel.newPassword.value"
                  :type="viewModel.isPwdVisible.value ? 'text' : 'password'"
                  label="Nueva Contraseña"
                  :rules="viewModel.passwordRules"
                  variant="outlined"
                  color="primary"
                  hide-details
                >
                  <template v-slot:append-inner>
                    <v-btn
                      icon
                      variant="plain"
                      @click="viewModel.togglePasswordVisibility"
                    >
                      <v-icon>{{
                        viewModel.isPwdVisible.value ? "mdi-eye-off" : "mdi-eye"
                      }}</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>

                <v-text-field
                  v-model="viewModel.confirmPassword.value"
                  :type="
                    viewModel.isConfirmPwdVisible.value ? 'text' : 'password'
                  "
                  label="Confirma tu Contraseña"
                  :rules="viewModel.confirmPasswordRules"
                  variant="outlined"
                  color="primary"
                  hide-details
                  class="mt-4"
                >
                  <template v-slot:append-inner>
                    <v-btn
                      icon
                      variant="plain"
                      @click="viewModel.toggleConfirmPasswordVisibility"
                    >
                      <v-icon>{{
                        viewModel.isConfirmPwdVisible.value
                          ? "mdi-eye-off"
                          : "mdi-eye"
                      }}</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-form>
            </v-card>
          </template>

          <!-- Acciones -->
          <template v-slot:actions>
            <div class="d-flex justify-space-between pt-4 mx-0 px-6">
              <v-btn
                variant="outlined"
                @click="viewModel.previousStep"
                :disabled="viewModel.step === 1"
                class="text-none"
              >
                Atrás
              </v-btn>
              <v-btn
                color="primary"
                class="text-white rounded-md text-none"
                :loading="viewModel.loading.value"
                @click="viewModel.nextStep"
              >
                {{ viewModel.step === 3 ? "Finalizar" : "Siguiente" }}
              </v-btn>
            </div>
          </template>
        </v-stepper>
        <v-col cols="12" class="pt-8">
          <p class="text-center flex justify-center items-center">
            <span class="text-subtitle-1">¿Ya estas registrado?</span>
            <router-link class="text-subtitle-1 text-primary" to="login">
              Inicia Sesión
            </router-link>
          </p>
        </v-col>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup>
import RecoveryPasswordViewModel from "@/viewmodels/auth/RecoveryPasswordViewModel";

const viewModel = new RecoveryPasswordViewModel();
</script>

<style scoped></style>
